<template>
  <div class="photo-archive-tag-panel">
    <b-row>
      <b-col md="6">
        <b-form-group label="Номер на груди">
          <div class="flex-row">
            <div class="tag-suggest-wrap">
              <b-form-input
                v-model="bibTag"
                placeholder="Номер участника"
                :disabled="isDisabled"
                autocomplete="off"
                @focus="onBibFocus"
                @blur="onBibBlur"
                @keyup.enter="submitBib"
              />
              <div
                v-if="isBibDropdownOpen && bibSuggestions.length"
                class="tag-suggest-dropdown"
              >
                <button
                  v-for="item in bibSuggestions"
                  :key="'bib-' + item"
                  type="button"
                  class="tag-suggest-item"
                  @mousedown.prevent="selectBibSuggestion(item)"
                >
                  {{ item }}
                </button>
              </div>
            </div>
            <b-spinner
              v-if="isBibSearchLoading"
              small
              class="ml-1"
            />
            <b-spinner
              v-if="isAddingTags"
              small
            />
            <plus-icon
              v-else
              size="1.5x"
              class="cursor"
              :class="{ 'disabled-icon': isDisabled }"
              @click="submitBib"
            />
          </div>
          <small class="text-muted">Привязка фото к участнику по номеру на груди</small>
        </b-form-group>
      </b-col>

      <b-col md="6">
        <b-form-group label="Общий тег">
          <div class="flex-row">
            <div class="tag-suggest-wrap">
              <b-form-input
                v-model="customTag"
                placeholder="финиш, награда, 21k..."
                :disabled="isDisabled"
                autocomplete="off"
                @focus="onCustomFocus"
                @blur="onCustomBlur"
                @keyup.enter="submitCustom"
              />
              <div
                v-if="isCustomDropdownOpen && customSuggestions.length"
                class="tag-suggest-dropdown"
              >
                <button
                  v-for="item in customSuggestions"
                  :key="'custom-' + item"
                  type="button"
                  class="tag-suggest-item"
                  @mousedown.prevent="selectCustomSuggestion(item)"
                >
                  {{ item }}
                </button>
              </div>
            </div>
            <b-spinner
              v-if="isCustomSearchLoading"
              small
              class="ml-1"
            />
            <plus-icon
              v-if="!isAddingTags"
              size="1.5x"
              class="cursor"
              :class="{ 'disabled-icon': isDisabled }"
              @click="submitCustom"
            />
          </div>
          <small class="text-muted">Смысловые метки: локация, момент, дистанция</small>
        </b-form-group>
      </b-col>
    </b-row>

    <div
      v-if="selectedCount > 0"
      class="selected-info text-muted"
    >
      Выбрано фото: {{ selectedCount }}
    </div>
  </div>
</template>

<script>
import {
  BCol,
  BFormGroup,
  BFormInput,
  BRow,
  BSpinner,
} from 'bootstrap-vue'
import { PlusIcon } from 'vue-feather-icons'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import crudModule from '@/libs/crud_module'

const albumPhotoModule = crudModule({
  entity_name: 'album/photo',
})

export default {
  name: 'PhotoArchiveTagPanel',
  components: {
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BSpinner,
    PlusIcon,
  },
  props: {
    startId: {
      type: [Number, String],
      default: null,
    },
    checkedPhotos: {
      type: Array,
      default: () => [],
    },
    albumId: {
      type: [Number, String],
      default: null,
    },
  },
  data() {
    return {
      bibTag: '',
      customTag: '',
      bibSuggestions: [],
      customSuggestions: [],
      isBibSearchLoading: false,
      isCustomSearchLoading: false,
      isBibDropdownOpen: false,
      isCustomDropdownOpen: false,
      bibSearchDebounceTimer: null,
      customSearchDebounceTimer: null,
      bibBlurTimer: null,
      customBlurTimer: null,
      isAddingTags: false,
    }
  },
  computed: {
    selectedCount() {
      return this.checkedPhotos.length
    },
    isDisabled() {
      return !this.startId || this.checkedPhotos.length === 0 || this.isAddingTags
    },
  },
  watch: {
    bibTag(val) {
      this.debouncedFetchBibSuggestions(val)
    },
    customTag(val) {
      this.debouncedFetchCustomSuggestions(val)
    },
  },
  beforeDestroy() {
    if (this.bibSearchDebounceTimer) clearTimeout(this.bibSearchDebounceTimer)
    if (this.customSearchDebounceTimer) clearTimeout(this.customSearchDebounceTimer)
    if (this.bibBlurTimer) clearTimeout(this.bibBlurTimer)
    if (this.customBlurTimer) clearTimeout(this.customBlurTimer)
  },
  methods: {
    onBibFocus() {
      if (this.bibBlurTimer) clearTimeout(this.bibBlurTimer)
      this.isBibDropdownOpen = true
      if (!this.bibTag.trim()) {
        this.fetchBibSuggestions('')
      }
    },
    onBibBlur() {
      if (this.bibBlurTimer) clearTimeout(this.bibBlurTimer)
      this.bibBlurTimer = setTimeout(() => {
        this.isBibDropdownOpen = false
      }, 150)
    },
    onCustomFocus() {
      if (this.customBlurTimer) clearTimeout(this.customBlurTimer)
      this.isCustomDropdownOpen = true
      if (!this.customTag.trim()) {
        this.fetchCustomSuggestions('')
      }
    },
    onCustomBlur() {
      if (this.customBlurTimer) clearTimeout(this.customBlurTimer)
      this.customBlurTimer = setTimeout(() => {
        this.isCustomDropdownOpen = false
      }, 150)
    },
    selectBibSuggestion(val) {
      this.bibTag = val
      this.isBibDropdownOpen = false
    },
    selectCustomSuggestion(val) {
      this.customTag = val
      this.isCustomDropdownOpen = false
    },
    debouncedFetchBibSuggestions(val) {
      if (this.bibSearchDebounceTimer) clearTimeout(this.bibSearchDebounceTimer)
      this.bibSearchDebounceTimer = setTimeout(() => {
        this.fetchBibSuggestions((val || '').trim())
      }, 250)
    },
    debouncedFetchCustomSuggestions(val) {
      if (this.customSearchDebounceTimer) clearTimeout(this.customSearchDebounceTimer)
      this.customSearchDebounceTimer = setTimeout(() => {
        this.fetchCustomSuggestions((val || '').trim())
      }, 250)
    },
    async fetchBibSuggestions(filterText) {
      if (!this.startId) return

      const client = this.$http || this.$axios
      if (!client) return

      this.isBibSearchLoading = true
      try {
        const { data } = await client.get(`photo-archive/starts/${this.startId}/bib-numbers`, {
          params: filterText ? { filterText } : {},
        })
        this.bibSuggestions = (Array.isArray(data) ? data : []).slice(0, 20)
      } catch (e) {
        this.bibSuggestions = []
      } finally {
        this.isBibSearchLoading = false
      }
    },
    async fetchCustomSuggestions(filterText) {
      if (!this.startId) return

      const client = this.$http || this.$axios
      if (!client) return

      this.isCustomSearchLoading = true
      try {
        const params = {
          start_id: this.startId,
          type: 'custom',
          maxResultCount: 20,
        }
        if (filterText) params.filterText = filterText

        const { data } = await client.get('albums-tags/photos/tags', { params })
        const raw = Array.isArray(data) ? data : data?.items || data?.data || []
        this.customSuggestions = (raw || [])
          .map(x => (typeof x === 'string' ? x : x?.name))
          .filter(Boolean)
          .slice(0, 20)
      } catch (e) {
        this.customSuggestions = []
      } finally {
        this.isCustomSearchLoading = false
      }
    },
    submitBib() {
      const tagName = (this.bibTag || '').trim()
      if (!tagName || this.isDisabled) return
      this.applyTags([{ name: tagName, type: 'bib' }])
      this.bibTag = ''
      this.bibSuggestions = []
    },
    submitCustom() {
      const tagName = (this.customTag || '').trim()
      if (!tagName || this.isDisabled) return
      this.applyTags([{ name: tagName, type: 'custom' }])
      this.customTag = ''
      this.customSuggestions = []
    },
    async applyTags(tags) {
      if (!this.checkedPhotos.length) return

      this.isAddingTags = true

      const photosWithTags = this.checkedPhotos.map(photo => ({
        id: photo.id,
        file_id: photo.file_id,
        tags,
      }))

      const payload = {
        album_id: this.albumId || this.checkedPhotos[0]?.album_id || this.checkedPhotos[0]?.album?.id,
        photos: photosWithTags,
        tags,
      }

      try {
        const response = await albumPhotoModule.updateItems(payload)
        const newTag = response.data

        this.checkedPhotos.forEach(photo => {
          if (!photo.tags) {
            photo.tags = []
          }
          tags.forEach(tag => {
            const exists = photo.tags.some(
              item => item.name === tag.name && item.type === tag.type,
            )
            if (!exists) {
              photo.tags.push(newTag?.id ? { ...newTag, ...tag } : tag)
            }
          })
        })

        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Уведомление',
            icon: 'BellIcon',
            text: 'Теги успешно добавлены',
            variant: 'success',
          },
        })
        this.$emit('tags-applied', { tags, photos: this.checkedPhotos })
      } catch (error) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Ошибка',
            icon: 'BellIcon',
            text: error?.response?.data?.message || 'Не удалось добавить теги',
            variant: 'danger',
          },
        })
      } finally {
        this.isAddingTags = false
      }
    },
  },
}
</script>

<style scoped lang="scss">
.flex-row {
  display: flex;
  gap: 12px;
  align-items: center;
}

.tag-suggest-wrap {
  position: relative;
  flex: 1 1 auto;
}

.tag-suggest-dropdown {
  position: absolute;
  top: calc(100% + 4px);
  left: 0;
  right: 0;
  z-index: 20;
  max-height: 220px;
  overflow-y: auto;
  background: #fff;
  border: 1px solid #d8d6de;
  border-radius: 4px;
  box-shadow: 0 4px 24px rgba(34, 41, 47, 0.1);
}

.tag-suggest-item {
  display: block;
  width: 100%;
  padding: 8px 12px;
  border: 0;
  background: transparent;
  text-align: left;
  cursor: pointer;

  &:hover {
    background: #f8f8f8;
  }
}

.cursor {
  cursor: pointer;
}

.disabled-icon {
  opacity: 0.5;
  cursor: not-allowed;
  pointer-events: none;
}

.selected-info {
  margin-top: 4px;
}
</style>
